/* eslint-disable max-lines */
import {AxiosRequestConfig} from 'axios';

import {
    ObjectType,
    DepStatus,
    PageScope,
    HomePageTabMenu,
    FollowType,
    IRepositoryRoleStatus,
    BonusType,
    ResignStatus,
} from './Constant';
import {
    COMMON_USE_KNOWLEDGE_EVENT_TYPE,
    COMMON_USE_KNOWLEDGE_TYPE,
    COMMON_USE_KNOWLEDGE_INVOLVEDTYPE,
    COMMON_USE_KNOWLEDGE_COLLECTION,
    HOMEPAGE_TAG,
    SELECT_DROPMENU,
} from '@/constants/home';
import {
    BookType,
} from '@/constants/document/doc';
import {RouteComponentProps} from 'react-router-dom';
import {TableRow} from './components/Table';
import {Group} from '@/domains/space/Department/Home/DepartmentKB/Table/interface';
import {ReactElement} from '@baidu/luffy/types';
import {PUBLISH_STATUS} from './constants/document/square';

// 0关闭 1开启 2 关闭 3开启 -1知识库默认关闭值
// 0 1 表示文档设置继承自知识库
// 2 3 表示文档设置了覆盖知识库
type PageSecurityStatus = -1 | 0 | 1 | 2 | 3;
export interface IPageSecurityParams {
    watermarkStatus: PageSecurityStatus; // 水印
    docCopyStatus: PageSecurityStatus; // 禁止复制
    downloadStatus: PageSecurityStatus; // 附件下载
    recommendStatus: PageSecurityStatus; // 助手推荐
    retrieveStatus: PageSecurityStatus; // 最近预览
    printPdfStatus: PageSecurityStatus; // 禁止打印/导出
    readerInviteReaderStatus: PageSecurityStatus; // 查看者邀请页面查看者
    editorInviteEditorStatus: PageSecurityStatus; // 编辑者邀请页面编辑者
    memberInviteReaderStatus?: PageSecurityStatus; // 知识库成员邀请邀请知识库只读成员
}
export interface IPageSecurityGetAccessId {
    spaceGuid?: string;
    groupGuid?: string;
    repositoryGuid?: string;
}
interface MatchParams {
    repositoryName: any;
    type?: string;
    tab?: string;
    userGuid?: string;
    spaceGuid?: string;
    groupGuid?: string;
    repositoryGuid?: string;
    docGuid?: string;
}

export type RoutePageProps = RouteComponentProps<MatchParams>;

export interface Props {
    className?: string;
    children?: React.ReactNode | React.ReactNode[];
    spaceGuid?: string;
    groupGuid?: string;
    repositoryGuid?: string;
    docGuid?: string;
}

export interface BindEventProps extends Props {
    onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export type TokenKey = 'wikiToken' | 'wikiAccessToken';

export interface WizRequestOptions extends AxiosRequestConfig {
    ticket?: string;
    wikiToken?: string;
    wikiAccessToken?: string;
    xWikiRteSToken?: string;
    returnFullResult?: boolean;
    returnFullError?: boolean;
    noCheckExists?: boolean;
    noRetry?: boolean;
    onlyRefreshToken?: boolean;
    uuapJumpUrl?: string;
    timeout?: number;
    noAutoLogin?: boolean;
    // 是否是as+ks的复合接口
    mergedRequestType?: string;
    noFrontTrace?: boolean;
    appId?: string;
    beforeJump?: () => void;
    ignoreUgateTokenInvalid?: boolean;
}

export interface LocaleData {
    [index: string]: string;
}

export interface LocalesData {
    [index: string]: LocaleData;
}

export interface StoreData {
    [index: string]: any;
}

export interface RouterItem {
    path: string;
    name: string;
}

export interface PathParams {
    [index: string]: string;
}

export interface SidebarListObj {
    value: any;
    setValue: any;
    scrollTo: (id: string) => void;
    selectNode: (id: string) => void;
}

export interface SidebarTreeObj {
    value: any;
    setValue: any;
    scrollTo: (target: string | number) => void;
    getSelectedKeys: () => string[];
    getExpandedKeys: () => string[];
    setSelectedKeys: (docGuids: string[]) => void;
    setExpandedKeys: (docGuids: string[]) => void;
    findNodeByParent: (parentGuid: string, {docGuid, name}: {docGuid?: string, name?: string}) => any;
}

export enum DocumentOperateType {
    Copy = 'copy',
    Create = 'create',
    Update = 'update',
    Delete = 'delete',
    Recovery = 'recovery',
    Convert = 'convert',
    Move = 'move',
    Inherit = 'inherit',
    Publish = 'publish',
    Knowledge = 'knowledge',
    Across = 'across',
    Test = 'test',
    Template = 'template',
    Rename = 'rename',
    Active = 'active',
}

export enum MemberOperateType {
    Add = 'add',
    Update = 'Update',
    Delete = 'Delete',
}

export enum TemplateType {
    User = 'user',
    System = 'system',
}

export enum DocumentUpdateOperation {
    Add = 'add',
    Update = 'update',
    Delete = 'delete',
}
export enum Ipermission {
    Read = PageScope.PagePublic,
    Edit = PageScope.PagePublicEdit,
}
export const ACHIEVE_LEVEL = {
    level1: 1,
    level2: 2,
    level3: 3,
    level4: 4,
    level5: 5,
    level6: 6,
} as const;

export type IAchieveLevel = typeof ACHIEVE_LEVEL[keyof typeof ACHIEVE_LEVEL];

export const ACHIEVE_LEVEL_STATUS = {
    alreadyGet: 20,
    noHaveOrDoing: 15,
} as const;

export type IAchieveLevelStatus = typeof ACHIEVE_LEVEL_STATUS[keyof typeof ACHIEVE_LEVEL_STATUS];

// knowledgeScout - 知识伯乐
// knowledgeExpert - 知识达人
export const ACHIEVE_TYPE = {
    knowledgeScout: 'knowledgeScout',
    knowledgeExpert: 'knowledgeExpert',
} as const;

export type IAchieveType = typeof ACHIEVE_TYPE[keyof typeof ACHIEVE_TYPE];

export const ACHIEVE_ICON_SOURCE = {
    achieveBtn: 'achieveBtn',
    dialogLarge: 'dialogLarge',
    dialogLevel: 'dialogLevel',
    exposedIcon: 'exposedIcon',
    exposedTopIcon: 'exposedTopIcon',
} as const;

export type IAchieveIconSource = typeof ACHIEVE_ICON_SOURCE[keyof typeof ACHIEVE_ICON_SOURCE];

export interface ILevelDetails{
    status: IAchieveLevelStatus;
    level: IAchieveLevel;
    target: number;
    achieveTime: number | null;
}
export interface IAchieveData{
    type: IAchieveType;
    name: string;
    level: IAchieveLevel;
    achieve: number;
    progress: number;
    details: ILevelDetails[];
}
// -------------------- wzz --------------------
export interface ICoinDocList {
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    docGuid: string;
    title: string;
    coinCount: number;
}

// User 已移动到 gloabl.d.ts 中维护
export interface User {
    squareUrl: string | undefined;
    id: number;
    userGuid: string;
    status: number;
    nickname: string | null;
    mobile: string | null;
    email: string | null;
    tenantId: string | null;
    avatar: string | null;
    localNumber: number;
    created: number;
    modified: number;
    token: string;
    department?: string;
    rlId: string;
    rlName: string;
    station?: string;
    tags?: string;
    createCount?: number;
    likeCount?: number;
    receivedCoinCount?: number;
    coinDocList?: ICoinDocList[];
    label?: string;
    snapshot?: string;
    settings: {
        trends: boolean;
        linking: boolean;
        citeReading: boolean;
        recommendReading: boolean;
        sendNotify: boolean;
        squareRecommend: boolean;
        newSettings: {
            notify: {
                // 原有字段
                at: boolean; // 其他人在知识库中@我
                permission: boolean; // 我在知识库中的权限变更
                repository: boolean; // 其他人在我知识库中的操作
                // 合并部分
                followUser: boolean; // 我关注的人有新的动态
                followDoc: boolean; // 我所关注的页面有新的动态
                followRepository: boolean; // 我所关注的知识库有新的动态
                // 新增部分
                followGroup: boolean; // 我关注的部门有新的动态
                atInGroup: boolean; // 其他人在部门中@我
                applyRepo: boolean; // 其他用户进行知识库权限申请
                applyGroup: boolean; // 其他用户进行部门角色权限申请
                groupApproval: boolean; // 其他用户进行部门相关操作审批
                managedGroupAction: boolean; // 其他人在我管理的部门中的操作
                groupNotice: boolean; // 部门公告发生变化
                groupPermission: boolean; // 我在部门中的权限变更
                subscribeUpdate: boolean; // 我关注的文档有更新
                subscribeComment: boolean; // 我关注的文档有评论更新
                subscribePermission: boolean; // 关注文档的权限变更

            };
            intelligent: { // 智能化相关设置字段
                linking: boolean; // 知识星链
                citeReading: boolean; // 文档引用
                recommendReading: boolean; // 相关推荐
                tagReading: boolean; // 智能标签
                useSpaceKey: boolean; // 智能创作快捷键
            };
            other: {
                autoSubscribe: boolean; // 自动关注自己创建的文档
            };
            interfaceDisplay: {
                showDongting: boolean; // 显示洞听
            };
        };
        me?: {
            at: boolean;
            permission: boolean;
            repository: boolean;
        };
        user?: {
            createDoc: boolean;
            updateDoc: boolean;
            createRepository: boolean;
            likeDoc: boolean;
            commentDoc: boolean;
            follow: boolean;
        };
        doc?: {
            updateDoc: boolean;
            commentDoc: boolean;
            deleteDoc: boolean;
        };
        repository?: {
            createDoc: boolean;
            updateDoc: boolean;
            deleteDoc: boolean;
            deleteRepository: boolean;
            updateNotice: boolean;
        };
        // newGuideIsRead?: boolean;
        newGuide?: {
            entranceIsRead?: boolean;
            newBuildIsRead?: boolean;
            customIsRead?: boolean;
            meetingModeIsRead?: boolean;
            endMeetingModeIsRead?: boolean;
            collaboratorAvatarGuideIsRead?: boolean;
            tagRecommendIsRead?: boolean;
            SettingModeIsRead?: boolean;
            myDepartmentIsRead?: boolean;
            mydepartRemindIsRead?: boolean;
            tagDepartKnowledgeIsRead?: boolean;
            ShareCollaborateIsRead?: boolean;
            createDirectoryGuideIsRead?: boolean;
            sheetGuideIsRead?: boolean;
            dataSheetGuideIsRead?: boolean;
            departmentHelpIsRead?: boolean;
            departVideoIsRead?: boolean;
            // 读写合一的提示
            unifyReadWriteIsRead?: boolean;
            searchPageIsRead?: boolean;

            // 侧边栏目录拖拽移入移除提示
            moveInBook?: boolean;
            moveOutBook?: boolean;
            // 0 没点过 1 点了第一步 2 点了第二步
            homeReadStep?: 0 | 1 | 2;
            // 数据归属公司声明
            isDataBelongsToCompany?: boolean;

            // 知识币
            knowledgeCoinDocFirstGuideIsRead?: boolean;
            knowledgeCoinDocSecondGuideIsRead?: boolean;
            knowledgeCoinKuToPersonalPageIsRead?: boolean;
            knowledgeCoinPersonalPageIsRead?: boolean;
            // 头像下菜单中知识库首页入口
            homeEntryIsRead?: boolean;
            // 发现页
            FindPageIsRead?: boolean;
            // 首页星标设置
            StarGroupSettingIsRead?: boolean;
            // 知识库智能问答页面开通引导
            QACenterOpenCardIsRead?: boolean;
            // 知识库智能问答页面开通引导红点
            QACenterOpenRedDotIsRead?: boolean;
            // 知识库智能问答页面使用引导
            QACenterUseCardIsRead?: boolean;
            // 知识库智能问答页面使用引导红点
            QACenterUseRedDotIsRead?: boolean;
        };
    };
    medal?: IAchieveData[];
    resignStatus?: ResignStatus;// 0：在职， 1：离职
    // 是否隐藏对话按钮
    canOpenSession?: boolean;
    external?: boolean; // 是否外部成员
    passportDisplayName?: string; // 外部账号显示的名称
}
// interface pubRepoList {
//     pubRepoList: number;
// }

export enum pubRepoList {
    public = 1,
    private = 0,
}

export interface DepartmentRepository {
    id: number;
    groupGuid: string;
    logo: string;
    scope: number;
    deadline: number;
    userGuid: string;
    intro: string;
    roleName: string;
    settings: {
        [key: string]: number;
    };
    tags: string[];
    status: number;
    roles: {
        Reader: string[];
        Member: string[];
        Admin: string[];
    };
    created: number;
    spaceGuid: string;
    modified: string;
    notice: string;
    ownerType: number;
    name: string;
}
// interface settingsObject {
//     pubRepoList: number;
// }

export interface UserDetail {
    user: User;
    repository: Repository;
    group: Group;
}

export interface WizLogDetail {
    eventGuid: string;
    action: number;
    type: number;
    timestamp: number;
    operator: {
        userGuid: string;
        nickname: string;
    };
    data: {
        doc?: {
            repositoryGuid: string;
            docGuid: string;
            name: string;
            type: number;
        };
        repository: {
            spaceGuid: string;
            groupGuid: string;
            repositoryGuid: string;
            name: string;
            ownerType: number;
            groupName?: string;
        };
        member?: {
            eventGuid: string;
            memberGuid: string;
            memberType: number;
            nickname: string;
            operation: string;
            roleName: string;
            message: string;
        };
        meta?: {
            update?: any;
            move?: any;
            source?: string;
            approval: string;
            approvalId?: string;
            notice: any;
            extra?: any;
            fileName?: string;
            hours?: number;
            comment?: {
                multi: boolean;
                commentGuid: string;
                anchorGuid: string;
            };
        };
        comment?: {
            content?: string;
        };
        group?: {
            spaceGuid: string;
            groupGuid: string;
            repositoryGuid: string;
            name: string;
        };
        // 知识库页面权限导出（站内信中的下载链接）
        download?: {
            url: string;
        };
    };
}
export interface WizLog {
    id: number;
    spaceGuid?: string;
    groupGuid?: string;
    repositoryGuid?: string;
    operatorGuid?: string;
    userGuid?: string;
    action: number;
    json: WizLogDetail;
    created: number;
}

export interface WizDocumentCreateDoc extends WizDocument {
    name: string;
    parentGuid: string;
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    position: number;
    bookType: BookType;
    scope?: number;
    inherit?: number;
}
export interface GroupWizDocument {
    version?: string;
    id?: number;
    serverGuid: string;
    parentGuid?: string | null;
    spaceGuid?: string;
    groupGuid?: string;
    repositoryGuid?: string;
    name?: string;
    userGuid?: string | null;
    created?: number;
    modified?: number;
    scope?: number;
    status?: number;
    abstract?: string | null;
    images?: string | null;
    position?: number;
    childCount?: number;
    log?: WizLog;
    operatorGuid?: string;
    operatorNickname?: string;
    docRoleName?: string;
    knowledge?: string;
    nickname?: string;
    latest?: boolean;
}

interface Mention {
    userGuid: string;
}
export interface DocumentUpdateData {
    operation?: DocumentUpdateOperation;
    action: DocumentOperateType;
    name?: string;
    position?: number;
    parentGuid?: string;
    repositoryGuid?: string;
    accessToken?: string;
    rteId?: string;
    mentions?: Mention[];
    sync?: boolean;
    permission?: Ipermission;
    isKeepPermission?: boolean;
    isCardView?: number;
    isFirstPublish?: number;
    isViewModified?: number;
    wordCount?: number;
}

export interface DocumentOperateData {
    docList?: WizDocument[];
    docGuidList?: string[];
    type: DocumentOperateType | '';
    updateType?: DocumentOperateType | '';
    timestamp?: number;
    data?: {
        url?: string;
        openInNewTab?: boolean;
        type?: number;
        [key: string]: any;
    };
}

export interface MemberForApproval extends TableRow {
    name: string;
    alias: string;
    roleName: string;
    status: string;
    memberId: string;
    memberGuid: string;
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    memberType: string;
    docGuid: string;
    eventGuid: string;
    type: string;
    label: string;
    isVirtualUser: string;
    external?: any; // 是否外部成员
}

export interface GroupMemberForApproval extends TableRow {
    roleName: string;
    memberId: string;
    memberGuid: string;
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    message: string;
    timestamp: string;
    eventGuid: string;
    name: string;
    action: string;
    type: string;
}

export interface Follow {
    id: number;
    followGuid: string;
    followGuider: string;
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    docGuid: string | null;
    name: string;
    repositoryName: string | null;
    userGuid: string | null;
    json: any;
    created: number;
    modified: number;
    objectType: ObjectType;
    status: number;
    type: number;
}

export interface Member {
    id?: number;
    memberGuid: string;
    alias?: string;
    nickname?: string;
    role?: string;
    spaceGuid?: string;
    groupGuid?: string;
    repositoryGuid?: string;
    eventGuid?: string;
    operation?: string;
    memberType?: number;
    status?: number;
    created?: number;
    modified?: number;
    message?: string;
    action?: string; // post data operation
    memberId?: string;
    type?: string;
    recommend?: boolean;
    channel?: any;
    roleName?: string;
}

export interface Message {
    id: number;
    messageGuid: string;
    action: number; // LogAction
    type: number;
    repositoryGuid: string | null;
    timestamp: number;
    sender: {userGuid: string, nickname: string};
    receiver: {userGuid: string, nickname: string};
    event: string | null;
    source: string;
    data: WizLogDetail;
    status: number;
}

export interface Record {
    id: number;
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    docGuid: string;
    userGuid: string;
    objectType: ObjectType;
    ownerType?: number;
    name: string;
    created: number;
    modified: number;
    type: number;
}

// ---------------------- xhz -----------------

export interface Template {
    id: number;
    name?: string;
    intro?: string | null;
    spaceGuid?: string;
    groupGuid?: string;
    repositoryGuid?: string;
    userGuid?: string;
    type?: TemplateType;
    created: number;
    modified?: number;
    docTemplates?: string;
    nickname?: string;
    rteId: string;
    docGuid?: string;
    version?: string;
    sysId?: number;
    docType: number;
    content: {
        children: any;
    } | null;
}

// ---------------------- xhz -----------------

export interface Share {
    scope?: number;
    password: string | null;
    expire?: number;
}

export interface VirtualUserProps {
    label: string;
    snapshot: string;
    isClosed: number;
    userGuid: string;
    nickname?: string;
}

export interface SinglePersonData {
    gid?: number | string;
    name?: string | undefined;
    rlId?: any;
    memberGuid: string;
    rocRoleName?: string;
    roleName?: string;
    memberType?: number;
    tenantId?: string | number | undefined;
    userGuid?: string;
    email?: string;
    id?: number;
    nickname?: string;
    avatar?: string;
    department?: string;
    status?: number;
    edit?: boolean;
    label?: string;
    isVirtualUser?: boolean;
    // emailGroup
    emailGroupAddress?: string;
    hlEmailGroupAddress?: string;
    docGuid?: string;
    repoRoleStatus?: IRepositoryRoleStatus;
    isSensitive?: boolean;
    virtualUser?: { // 虚拟账号相关类型定义
        id: number;
        userGuid: string;
        nickname: string;
        avatar: string;
        email: string;
        department: string;
        label: string;
        snapshot: string;
    };
    avatarUrl?: string;
    uid?: string;
    userId?: string;
    external?: boolean; // 是否外部成员
    passportDisplayName?: string;
    isExternalUser?: boolean; // 是否为外部账号
    mobile?: number | string;
}

export interface Tag {
    source: string;
    score: number;
    value: string;
    type: string;
}

export interface ILikeListData {
        userGuid?: string;
        spaceGuid?: string;
        groupGuid?: string;
        repositoryGuid?: string;
        docGuid?: string;
        title?: string;
        link?: string;
        likeTime?: number;
        blockId?: string;
}
export interface coinDynamic {
    action: number;
    changeCoinCount: number;
    created?: number;
    bonusType?: BonusType;
    // 生产
    produceInfo: {
        userGuid?: string;
        nickname?: string;
        startDate?: number;
        endDate?: number;
        produceCoinCount?: number;
        pv?: number;
    };
    // 奖励
    rewardInfo: {
        giverUserGuid?: string;
        giverNickname?: string;
        receiverGuid?: string;
        receiverNickname?: string;
        repositoryGuid?: string;
        knowledgeType?: number;
        knowledgeGuid?: string;
        knowledgeTitle?: string;
        knowledgeUrl?: string;
        spaceGuid?: string;
        groupGuid?: string;
        coinCount?: number;
        detail?:{
            description?: string;
            linkUrl?: string;
            linkTitle?: string;
            suffix?: string;
        };
        // created?: number;
    };
    // 中奖
    bonusInfo: {
        reward: {
            knowledgeCoinGuid: string;
            receiverGuid: string;
            receiverNickname: string;
        };
        publishDoc: {
            spaceGuid?: string;
            groupGuid?: string;
            repositoryGuid?: string;
            docGuid?: string;
            knowledgeGuid?: string;
            title?: string;
            url?: string;
        };
        activity: {
            spaceGuid?: string;
            groupGuid?: string;
            repositoryGuid?: string;
            docGuid?: string;
            knowledgeGuid?: string;
            title?: string;
            url?: string;
        };
        docShare: {
            spaceGuid?: string;
            groupGuid?: string;
            repositoryGuid?: string;
            docGuid?: string;
            knowledgeGuid?: string;
            title?: string;
            url?: string;
        };
    };
}
export interface RecentDynamicData {
    id?: number;
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    docGuid: string;
    docName: string;
    fromUserGuid: string;
    fromNickname: string;
    fromUserEmailPrefix?: string;
    notificationType: number;
    sendTime: number;
    readType?: number;
    blockId?: string;
}
// export interface RecentDynamicData {
//     id: string;
//     giverUserGuid: string;
//     giverNickname: string;
//     repositoryGuid: string;
//     knowledgeType: string;
//     knowledgeGuid: string;
//     knowledgeTitle: string;
//     knowledgeUrl: string;
//     coinCount: string;
//     created: string;
// }

export interface LikeData {
    docGuid: string;
    repositoryGuid: string;
    nickname: string;
    userGuid: string;
}

export interface CommentItem {
    commentGuid: string | '';
    content: any;
    created: number;
    docGuid: string | '';
    id: number;
    status: number;
    modified: number;
    nickname: string | '';
    parentGuid: string | '';
    repositoryGuid: string | '';
    userGuid: string | '';
    child?: any[];
    replyId?: string | number;
    replyContent?: any;
    rootGuid: string;
    replyPersonName?: string;
    isManagerDeleted?: boolean;
    level?: number;
    isDeleted?: boolean;
    parent?: CommentItem;
    isFold?: boolean;
    /**
    * 是否为旧的评论数据，1 为新的格式数据（JSON）、0 或没传则为旧数据（纯字符串）
    */
    sourceType?: 0 | 1;
    parentId?: number;
    src?: string;
}
export interface PowerListOption {
    label: string | Element | ReactElement;
    produce?: string;
    value: string | number;
    isChecked?: boolean;
    disabled?: boolean;
    btnName?: string;
    visible?: boolean;
}

export interface MemberOperateData {
    type: MemberOperateType;
    repositoryGuid: string;
    time: number;
    memberGuid?: string[];
    updateRoleName?: string;
}

export interface DocMembers {
    members?: Member[];
    roleName?: string;
    action?: string;
    message?: string;
    receiverGuid?: string;
    channel?:any;
}

export interface MemberSettingMe {
    me: boolean;
    permission: boolean;
    repository: boolean;
}

export interface MemberSettingUser {
    createDoc: boolean;
    updateDoc: boolean;
    createRepository: boolean;
    likeDoc: boolean;
    commentDoc: boolean;
    follow: boolean;
}

export interface MemberSettingDoc {
    commentDoc: boolean;
    updateDoc: boolean;
    deleteDoc: boolean;
}

export interface MemberSettingRepo {
    commentDoc: boolean;
    updateDoc: boolean;
    deleteDoc: boolean;
    deleteRepository: boolean;
    updateNotice: boolean;
}
export interface SearchMemberSettings {
    trends: boolean;
    me: MemberSettingMe;
    user: MemberSettingUser;
    doc: MemberSettingDoc;
    repository: MemberSettingRepo;
}
export interface SearchMember {
    // [x: string]: any;
    mobile: string | null;
    // @todo status 定义
    status: number;
    nickname: string;
    department: string;
    rlId?: string;
    email?: string;
    userGuid: string;
    tenantId: string;
    localNumber: number;
    created: number;
    modified: number;
    rlName: string;
    settings: SearchMemberSettings;
    // @todo memberType 定义
    memberType: number;
    label?: string;
    isVirtualUser?: boolean;
}

export interface DepSettings {
    pubRepoList: pubRepoList;
}
export interface Recommend {
    spaceGuid?: string;
    groupGuid?: string;
    repositoryGuid?: string;
    objectType?: ObjectType;
}

export interface Department {
    id?: number;
    spaceGuid?: string;
    groupGuid?: string;
    name?: string;
    userGuid?: string;
    scope?: number | null;
    ownerType?: number;
    // 部门存在状态
    status?: DepStatus;
    // 部门开通状态
    orgStatus?: number;
    // 部门失效状态（部门失效后依然可进入页面，组织不行）
    erpStatus?: number;
    notice?: {
        spaceGuid?: string;
        groupGuid?: string;
        userGuid?: string;
        nickname?: string;
        title?: string;
        content?: string;
        id?: number;
        created?: number;
        modified?: number;
        status?: number;
    } | null;
    intro?: string | null;
    logo?: string | null;
    roles?: {
        Admin: string[];
        Member: string[];
        Reader: string[];
        DocMember: string[];
        DocReader: string[];
    };
    created?: number;
    modified?: number;
    deadline?: number;
    tags?: string[];
    settings?: DepSettings;
    roleName?: string;
    tranceId?: string;
    memberCount?: number;
    repositoryGuid?: string;
    repositoryCount?: number;
    docCount?: number;
    ownerUuapName?: string;
    follow?: any;
    groupType?: 'D+' | 'D';
}

export type DepInfo = Pick<Department, 'intro' | 'notice' | 'tags' | 'settings'>;

export interface Comment {
    parentGuid?: string;
    rootGuid?: string;
    content?: string;
}
export interface departmentRoleName {
    AAOwner: 'AAOwner';
    Admin: 'Admin';
    Member: 'Member';
}
export enum DepartmentRoleName {
    AAOwner = 'AAOwner',
    Admin = 'Admin',
    Member = 'Member'
}
// 搜索

export enum OWNER_TYPE {
    User = 5,
    FREE = 10,
    VIP = 15,
    Tenant = 20,
    Space = 25,
    Group = 30,
    Repository = 35,
}
export interface SearchParams {
    spaceGuid: string;
    q: string;
    type: string;
    start: number;
    end: number;
    modifiers: string;
    repositoryGuid: string;
    page: number;
    pageSize: number;
}

export interface SearchData {
    spaceGuid?: string;
    groupGuid?: string;
    repositoryGuid?: string;
    docGuid?: string;
    docType?: string | null;
    name?: string;
    type?: string;
    status?: number;
    content?: string;
    updateTime?: string | number;
    createTime?: string | number;
    creator?: string;
    lastModifier?: string;
    repositoryName?: string;
    intro?: string;
    ownerType?: OWNER_TYPE;
    authName?: number;
    repoMemberNum?: number;
    browseTime?: number;
    avatarUrl: string;
    email: string;
    homepageUrl: string;
    nickname: string;
    orgChainName: string;
    userName?: string;
}
export interface CreateRepo {
    visible: boolean;
    isInList?: boolean;
    setReload?: (arg: number) => void;
}

export interface DragOption {
    sidebarWidth: number;
    lastSidebarWidth: number;
    sidebarOpen: boolean;
}


export interface NameWarnInfo {
    maxLengthWarn?: boolean;
    emptyName?: boolean;
    repeatWarn?: boolean;
}

export interface SidebarWidthChangeInfo {
    width: number;
    isClick: boolean;
}

export interface INewVersionInfo {
    docGuid?: string;
    uids?: string[];
    reload?: number;
}

export interface ICommentCount {
    commentAllCount?: number;
    underlineCommentCount?: number;
}
export interface IpageInfo {
    repositoryGuid: string;
    pageNum: number;
    pageSize: number;
}

export interface IRteToken {
    accessToken: string;
    sdkId?: string;
    docGuid?: string;
}

export interface IRecentlyListParams {
    spaceGuid?: string;
    groupGuid?: string;
    repositoryGuid?: string;
    docGuid?: string;
    type?: string;
    source?: string;
}

export type IPublishStatus = typeof PUBLISH_STATUS[keyof typeof PUBLISH_STATUS];
export interface IPublishSquareData {
    status: IPublishStatus;
    operatorGuid?: string;
    operatorNickname?: string;
    rlName?: string;
    articleStatus?: string; // 'AUDITING' | 'FAILED' | 'RECOMMENDING' | 'NORMAL'
    // 已同步最新版本
    published?: boolean;
    avatar?: string;
}
// 首页常用列表
export interface ICommonUseKnowledge {
    id?: string;
    spaceGuid?: string;
    groupGuid?: string;
    repoGuid?: string;
    docGuid?: string;
    name?: string;
    type?: typeof COMMON_USE_KNOWLEDGE_TYPE[keyof typeof COMMON_USE_KNOWLEDGE_TYPE];
    order?: number;
    event?: string;
    eventType?: typeof COMMON_USE_KNOWLEDGE_EVENT_TYPE[keyof typeof COMMON_USE_KNOWLEDGE_EVENT_TYPE];
    created?: string;
    modified?: string;
    repoInfo?: {
        avatar?: string;
        nickname?: string;
        ownerType?: number;
    };
}

// 以下是首页列表相关
export interface ICooperationShare {
    userGuid?: string;
    department?: string;
    name?: string;
    email?: string;
    rlName?: string;
    content?: string;
}
export interface ITableData {
    id?: string;
    type?: typeof COMMON_USE_KNOWLEDGE_COLLECTION[keyof typeof COMMON_USE_KNOWLEDGE_COLLECTION];
    name?: string;
    upName?: string;
    involvedType?: typeof COMMON_USE_KNOWLEDGE_INVOLVEDTYPE[keyof typeof COMMON_USE_KNOWLEDGE_INVOLVEDTYPE];
    // event?: string;
    // eventType?: typeof COMMON_USE_KNOWLEDGE_EVENT_TYPE[keyof typeof COMMON_USE_KNOWLEDGE_EVENT_TYPE];
    // created?: string;
    // // 先按editTimestamp作为时间计算
    // editTimestamp?: number;
    // modified?: number;
    time?: number;
    follow?: boolean;
    followGuid?: string;
    homepage?: boolean;
    spaceGuid?: string;
    groupGuid?: string;
    repoGuid?: string;
    repositoryGuid?: string;
    docGuid?: string;
    docName?: string;
    roleName?: string;
    cooperation?: {
        type?: string;
        comment?: string;
        share?: ICooperationShare;
        at?: ICooperationShare;
    };
    recordStatus?: number;
    repoInfo?: {
        avatar?: string;
        nickname?: string;
        ownerType?: number;
    };
    labelIds?: number[];
    subscribeStatus?: {
        comment: number;
        share: number;
        update: number;
        permission: number;
    };
}
export const HOMEPAGE_COLUMN_COMP_NAME = {
    renderName: 'renderName',
    renderUpName: 'renderUpName',
    renderTime: 'renderTime',
    renderCooper: 'renderCooper',
    renderOperation: 'renderOperation',
    renderRole: 'renderRole',
    renderStarGroup: 'renderStarGroup',
    renderSubscribeStatus: 'renderSubscribeStatus',
} as const;

export type HomePageColumnCompName = typeof HOMEPAGE_COLUMN_COMP_NAME[keyof typeof HOMEPAGE_COLUMN_COMP_NAME];
// menu配置
export interface IMemuOptionList {
    value: HomePageTabMenu;
    name: string;
    icon: React.FunctionComponent;
}
export type HomePageTag = typeof HOMEPAGE_TAG[keyof typeof HOMEPAGE_TAG];
export type SelectDropMenu = typeof SELECT_DROPMENU[keyof typeof SELECT_DROPMENU];
// tag集合
interface TagOptionColumnList {
    title: string;
    renderKey: HomePageColumnCompName;
}
export interface ITagOptions {
    value: HomePageTag;
    label: string;
    name: string;
    // timeTitle: string;
    disbled?: boolean;
    column: TagOptionColumnList[];
}
export interface IPosition {
    menu: string;
    tag: string;
    select: string;
}

export interface SearchParamsFromSearchPage {
    query: string;
    repoGuid?: string;
    type?: number | string; // 文档类型  1 知识库 2 知识本 3 文档 4 表格
    page: number;
    pageSize: number;
    start?: number; // 开始时间
    end?: number; // 结束时间
    isAuthority?: number | string; // 1 全部 2 有权限
    match?: number | string; // 1 正文 2 标题
    spaceGuid?: string;
}

export enum HOT_LIST_TAG {
    hotUp = '上升',
    vLook = '大咖在看',
    hotNew = '新',
}
export interface IHasFollowStarParams {
    type: FollowType;
    spaceGuid?: string;
    groupGuid?: string;
    repositoryGuid?: string;
    docGuid?: string;
    userGuid?: string;
}
export interface IFollowStarParams {
    type: FollowType;
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid?: string;
    docGuid?: string;
    userGuid?: string;
}
export interface IUnFollowStarParams {
    type: FollowType;
    followGuid: string;
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid?: string;
    docGuid?: string;
}

export interface IUnderlineCommentNotice {
    commentGuid: string;
    rootComment: {
        commentGuid: string;
        userGuid: string;
    };
    anchorGuid: string;
}
export interface GroupInfo {
    groupId: string | number;
    groupName: string;
    groupMembers?: string[];
    groupAvatar?: string;
    replyId?: string;
}
export interface CoinData {
    docGuid: string;
    repositoryGuid: string;
    giverNickname: string;
    giverUserGuid: string;
}
interface IKnowledgeProgress {
    currentView: number;
    targetView: number;
    targetCoinCount: number;
    modified: string;
}
interface IReceivedCoinInfo{
    docCoinCount: number;
    docCoinCountToday: number;
    docCoinCountYesterday: number;
    activityCoinCount: number;
    activityCoinCountToday: number;
    activityCoinCountYesterday: number;
}
export interface IUserCoinInfo {
    receivedCoinCount?: number;
    receivedCoinInfo?: IReceivedCoinInfo;
    produceCoinCount?: number;
    availableCoinCount?: number;
    hasGiveAtToday?: boolean;
    hasGiveAtThisWeek?: boolean;
    knowledgeProgress: IKnowledgeProgress;
    exchangeableCoinCount?: number;
    canExchangeEasyCoin?: boolean;
    traceId?: string;
    requestDone?: boolean;
}

interface IUserAwards{
    userGuid:string;
    knCoinCount:string;
    createCount:string;
}
interface IKnowledgeCoinAwards{
    knCoinCount:number;
    personCount:number;
    receivedCoinInfo:{
        activityCoinCount: number | undefined;
        knCoinCount:number;
        personCount:number;
        docCoinCount:number;
        docCoinCountToday:number;
        docCoinCountYesterday:number;
    };
userAwardsList:IUserAwards[];
}
interface ILikedAwards{
    likedCount:number;
    personCount:number;
    likedCountToday:number;
    likedCountYesterday:number;
    userAwardsList:IUserAwards[];
}
export interface IUserAchieveAwards{
    knowledgeCoinAwards: IKnowledgeCoinAwards;
    likedAwards:ILikedAwards;
    starCount:number;
    referencedCount:number;
    openDocCount:number;
    openDocReadCount:number;
    updateTime:number;
}

export interface ICreationReadData {
    createCount?: number;
    readCount?: number;
    openDocCount?: number;
    openDocReadCount?: number;
    knowledgeCoinAwards?: {
        knCoinCount?: number;
    };
    likedAwards?: {
        likedCount?: number;
    };
    updateTime?: number;
}

export interface IStarGroupData {
    id: number;
    labelName: string;
}
export const JUMP_TYPE = {
    department: 1,
    repository: 2,
    document: 3,
} as const;
export type IJumpType = typeof JUMP_TYPE[keyof typeof JUMP_TYPE];

export const USERINFO_TOOLTIP_CARD_TYPE = {
    normal: 'normal',
    editor: 'editor',
    search: 'search',
} as const;

export type UserInfoTooltipCardType = typeof USERINFO_TOOLTIP_CARD_TYPE[keyof typeof USERINFO_TOOLTIP_CARD_TYPE];

export enum SideTabKey {
    Ai = 'ai',
    Comment = 'comment',
    Material = 'material',
}

export interface IAiChatPanel {
    isExpanded: boolean;
    selectedTab: SideTabKey;
    isAiAssistant?: boolean; // 是否是助手sdk
    isExternalNotComment: boolean; // 填坑：需要标识面板展开是由外部触发，而不是评论触发。
    docGuid: string; // 绑定文档
    showCommentBg?: boolean; // 划线评论的假背景，用于优化切换文档和状态时划线评论闪动问题
}

export interface IPublishListData{
    docGuid: string;
    title: string;
    docUrl: string;
    docViews: number;
    docComments: number;
    docLikes: number;
    docCoins: number;
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    repositoryName: string;
    repositoryUrl: string;
    repositoryOwnerType: number;
    modifiedTime: number;
    modifier: string;
    creatorNickname: string;
    modifierNickname: string;
    suggestionDocTagList: Array<{
        name: string;
        type: number;
    }>;
}

interface ITag{
    type: number;
    tagName: string;
    kuGroup: number;
    group: number;
}
export interface IHighQualityData {
    title: string;
    rank: null;
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    docGuid: string;
    abstracts: string; // 摘要
    creatorGroupGuid: string; // 文档创建人所属部门ID
    creatorGroupName: string;
    repositoryName: string; // 文档知识库名称
    repositoryUrl: string;
    repositoryOwnerType: number;
    docViews: number;
    docLikes: number;
    docCoins: number;
    tags: ITag[];
    source: number;
    intimateViewers?: []; // 亲密度用户浏览列表
    intimateViewerCount?: number;
    intimateLikers: null; // 亲密度用户点赞列表
    intimateCoinGivers: null; // 亲密度用户投币列表
    created: number; // 创建时间
    creator: string; // 创建人ID
    creatorNickname: string;
    modified: number; // 发布时间
    modifier: string;
    modifierNickname: string;
    publishTime: number;
    repoGuid: string;
    userGuid: string;
    score: number;
}

export enum chatRepoInitStatusType {
    initError = -1, // -1初始化失败
    initLoading = 1, // 1初始化中
    initSuccess = 2, // 2初始化完成
}
export interface QASettingsData {
    chatRepo?: string; // 是否开始知识库问答
    recommends?: string[]; // 用于设置中的推荐问题展示，问答页面的三个问题，需要另外调接口获取
    welcome?: string;
    chatRepoInitStatus?: chatRepoInitStatusType; // 知识库问答初始化状态
    fallback?: string;
}

export interface MemberCountType {
    repoMemberCount: string;
    docMemberCount: string;
    bookMemberCount: string;
    repoCounting: boolean;
    docCounting: boolean;
    bookCounting: boolean;
}
export const recommednFeedAction = {
    up: 'up',
    init: 'init',
    down: 'down',
} as const;

export interface PowerRecycleInfo {
    riskCount: number;
    userCount: number;
}

export enum PowerWarnStatus {
    resolve = 0,
    notResolve = 1,
}
export interface PowerWarnData {
    id: number;
    departUserNum: number;
    departRepoNum: number;
    departDocNum: number;
    transRepoNum: number;
    transDocNum: number;
    transUserNum : number;
    status: PowerWarnStatus;
    created: number;
}

// 风险回收搜索人员条件信息
export interface PowerSearchInfo {
    nickname: string;
    userGuid: string;
}

export interface InteractionDetail {
    type: string;
    count: number;
}
export interface InteractionResult {
    userGuid: string;
    userAvatar: string;
    userNickname: string;
    details: InteractionDetail[];
}
export interface IInteractionData {
    dataTime: string;
    count: number;
    data: InteractionResult[];
}

export interface PublishDoc {
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    docGuid: string;
    title: string;
    docViews: number;
    docCoins: number;
    creator: string;
    creatorNickname: string;
    publishTime: string;
}
export interface IOtherPublishData {
    count: number;
    data: PublishDoc[];
}

export type IRecommednFeedAction = typeof JUMP_TYPE[keyof typeof JUMP_TYPE];

export interface TipsDocInfo {
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    docGuid: string;
    title: string;
}
export interface PublicSuggestionTipsInfo {
    pageType: number;
    docInfoList: TipsDocInfo[];
    count: number;
    bigShotUserGuidList: string[];
}
export interface IDocCardLikeInfo {
    blockId: string;
    likeCount: number;
    userLike: boolean;
}

export interface ICurDocCardLikesInfo {
    docGuid: string;
    initTime: number;
    likeInfoList: IDocCardLikeInfo[];
}

// 定义一些挂载到window的变量
declare global {
    interface Window {
      BdHiJs: any;
      onBdHiJsReady: () => void;
      kuShareTraceId: string;
      // isTocPage: 外部知识库的标识，后面所有需要区分厂内知识库和厂外知识库的场景，都用这个字段
      isTocPage: boolean;
    }
}
